import React, { useContext, useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import {
	Button,
	Form,
	FormGroup,
	Label,
	Col,
} from 'reactstrap';
// import Datepicker from 'react-datepicker';
import Select from 'react-select';
import Datetime from 'react-datetime';
import { Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import { DESA, Get, JENIS_DESA, JENIS_DUSUN, KECAMATAN, Nama_DESA, NAMA_KABUPATEN, Post, PROVINSI } from '../../function/Koneksi';
import { generateAlamat, Tanggal } from '../../function/Format';

const ModalSuratUsaha = ({ data, optionData, setAlert, isOpen, setIsOpen, statusRefresh, setStatusRefresh, propsData, kiosk }) => {
	const dateFormat = require('dateformat');

	const frmDex = {
		uuid: '',
		id_jenis: '',
		nik_pelapor: '',
		nik: '',
		kk: '',
		nama_pemohon: '',
		tempat_lahir: '',
		tanggal_lahir: '',
		jenis_kelamin: '',
		pekerjaan: '',
		pendidikan_terakhir: '',
		kewarganegaraan: "Indonesia",
		agama: '',
		alamat: '',
		status_perkawinan: '',
		tujuan_pembuatan: '',
		detail: []
	}

	const initFormData = {
		frmNik: optionData.frmNik,
		frmShdk: optionData.frmShdk,
		frmNik3: optionData.frmNik3,
		tmplistPenduduk: optionData.tmplistPenduduk,
		tmplistPenduduk3: optionData.tmplistPenduduk3,
		nikStat: null,
		nik3Stat: null,
		shdk_aw: null,
		jenisForm: "usaha",
		dataUsaha: [],
		status: {
			form: false,
			btnForm: false,
			btnAksi: [],
			dataPenduduk: "none",
		},
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
	}

	const [formData, setFormData] = useState(initFormData)
	const [props, setProps] = useState(propsData)
	const [kioskMode, setKioskMode] = useState(kiosk)
	const [dt, setDt] = useState(data ? data : frmDex)
	const [draggable, setDraggable] = useState({
		isDown: false,
		startY: null,
		scrollUp: null,
	})

	useEffect(() => {
		if (document.getElementById("modalForm")) {
			document.getElementById("modalForm").reset()
		}

		setDt(data ? data : frmDex)
		setFormData(data ? {
			...initFormData,
			nikStat: optionData.nikStat,
			status: optionData.status,
			jenisForm: optionData.jenisForm,
			dataUsaha: optionData.dataUsaha,
		} : initFormData)
	}, [isOpen])

	const handleInputChangeNIK = (e, fld) => {
		if (e && kioskMode == false) {
			let nikStat = { value: e, label: e };

			Post("penduduk", null, { nik: e }, datanik => {
				let frmNik = [];
				let tmplistPenduduk = {}
				datanik.data.results.data.forEach(dt => {
					frmNik.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
					tmplistPenduduk = {
						...tmplistPenduduk,
						[dt.id]: dt
					}
				});

				switch (fld) {
					case "nik":
						setFormData({
							...formData,
							frmNik,
							tmplistPenduduk,
							nikStat
						})
						break;

					default:
						break;
				}

			});

		}
	};

	const changeInputText = (e, fld) => {
		switch (fld) {
			case "penghasilan":
				setDt({
					...dt,
					penghasilan: e.target.value,
				})
				break;
			default:
				// no default
				break;
		}
	};

	const getPenduduk = (e) => {
		if (e) {
			
            if (kioskMode) {
                props.setLoadingPreview(true)
            }
            else{
                setAlert({
                    loadingPreview: true
                })
            }

            Get("penduduk/find", e.value, data => {
                if(data.results){
                    const alamat = generateAlamat(data.results);
                    let alamat_kk = "";
                
                    if(data.results.data_kk){
                        alamat_kk = data.results.data_kk.alamat
                    }

                    setFormData({
                        ...formData,
                        nikStat: e,
                        status: {
                            ...formData.status,
                            dataPenduduk: "block",
                        },
                    })

                    setDt({
                        ...dt,
                        nik: data.results.id,
                        nik_pelapor: data.results.id,
                        kk: data.results.id_kk,
                        nama_pemohon: data.results.nama,
                        tempat_lahir: data.results.tempat_lahir,
                        tanggal_lahir: new Date(
                            data.results.tanggal_lahir
                        ),
                        pekerjaan: data.results.data_pekerjaan.nama,
                        pendidikan_terakhir: data.results.data_pendidikan_terakhir.nama,
                        agama: data.results.data_agama.nama,
                        status_perkawinan: data.results.status_perkawinan,
                        jenis_kelamin: data.results.jk,
                        alamat: alamat,
                        alamat_kk: alamat_kk,
                        kewarganegaraan: 'Indonesia',
                    })
                    
                    if (kioskMode) {
                        props.setLoadingPreview(false)
                    }
                    else{
                        setAlert({
                            loadingPreview: false
                        })
                    }

                }
                else{
                    if (kioskMode) {
                        props.setLoadingPreview(true)
                    }
                    else{
                        setAlert({
                            loadingPreview: true
                        })
                    }
                }
            })

		} else {
			setDt({
				...dt,
				nik: '',
				nik_pelapor: '',
				kk: '',
				nama_pemohon: '',
				tempat_lahir: '',
				tanggal_lahir: '',
				pekerjaan: '',
				pendidikan_terakhir: '',
				agama: '',
				status_perkawinan: '',
				jenis_kelamin: '',
				alamat: '',
				alamat_kk: '',
				kewarganegaraan: 'Indonesia',
			})
			setFormData({
				...formData,
				status: {
					...formData.status,
					dataPenduduk: "none"
				},
				nikStat: null,
			})
		}
	};

	const labelJenisStyle = (field) => {
		if (formData.jenisForm === field) {
			return {
				backgroundColor: "grey"
			}
		} else {
			return {
				backgroundColor: "transparent",
				borderBottom: "1px solid grey"
			}
		}
	}

	const textColorStyle = (field) => {
		if (formData.jenisForm === field) {
			return "white"
		} else {
			return "black"
		}
	}

	const addUsaha = e => {
		e.preventDefault();
		if (formData.jenisForm === "usaha") {
			if (
				document.getElementById("jenis_usaha").value !== "" &&
				document.getElementById("nama_tempat_usaha").value !== "" &&
				document.getElementById("lokasi").value !== ""
			) {
				let data = {
					jenis_usaha: document.getElementById("jenis_usaha").value,
					nama_tempat_usaha: document.getElementById("nama_tempat_usaha").value,
					lokasi: document.getElementById("lokasi").value
				};
				// this.setState({ dataUsaha: [...formData.dataUsaha, data] });
				setFormData({
					...formData,
					dataUsaha: [
						...formData.dataUsaha,
						data
					]
				})
				document.getElementById("jenis_usaha").value = "";
				document.getElementById("nama_tempat_usaha").value = "";
				document.getElementById("lokasi").value = "";

				// For testing
				if (props.getDataUsaha) {
					props.getDataUsaha(formData.dataUsaha)
				}
			} else {
				const alertData = {
					show: true,
					basicType: "warning",
					basicTitle: "Data Belum Lengkap",
					pesanAlert: "Silahkan lengkapi data usaha"
				};
				setAlert(alertData)
			}
		} else { // Jika kebun
			if (
				document.getElementById("jenis_usaha").value !== "" &&
				document.getElementById("umur").value !== "" &&
				document.getElementById("lokasi").value !== "" &&
				document.getElementById("luas_kebun").value !== ""
			) {
				let data = {
					jenis_usaha: document.getElementById("jenis_usaha").value,
					umur: document.getElementById("umur").value,
					lokasi: document.getElementById("lokasi").value,
					luas_kebun: document.getElementById("luas_kebun").value
				};
				setFormData({
					...formData,
					dataUsaha: [
						...formData.dataUsaha,
						data
					]
				})
				// this.setState({ dataUsaha: [...formData.dataUsaha, data] });
				document.getElementById("jenis_usaha").value = "";
				document.getElementById("umur").value = "";
				document.getElementById("lokasi").value = "";
				document.getElementById("luas_kebun").value = "";


				// For testing
				if (props.getDataUsaha) {
					props.getDataUsaha(formData.dataUsaha)
				}
			} else {
				const alertData = {
					show: true,
					basicType: "warning",
					basicTitle: "Data Belum Lengkap",
					pesanAlert: "Silahkan lengkapi data usaha"
				};
				setAlert(alertData)
			}
		}
	};

	const hapusUsaha = id => {
		let data = formData.dataUsaha;
		data.splice(id, 1);
		setFormData({
			...formData,
			dataUsaha: data
		})
		// this.setState({ dataUsaha: data });
	};

	const hapusDetail = (i) => {
		console.log(i);
		// let currDetail = dt.detail
		let newDetail = dt.detail.splice(i, 1)

		// console.log(currDetail);
		console.log(newDetail);
		console.log(dt.detail);

		setDt({
			...dt,
			detail: dt.detail
		})
	};

	const simpan = (e) => {
		e.preventDefault();

        if (kioskMode){
            props.setLoadingPreview(true)
        }
        else{
            setAlert({
                loadingPreview: true
            })
        }

		let validasiPelapor = formData.nikStat;

		if (formData.dataUsaha.length === 0) {
			if (kioskMode){
				props.setLoadingPreview(false)
			}
			else{
				setAlert({
				  loadingPreview: false
				})
			}
			const alertData = {
				show: true,
                basicType: "warning",
                basicTitle: "Data Belum Lengkap",
                pesanAlert: "Silahkan isi data usaha"
			}
			setAlert(alertData)
		} else if (validasiPelapor) {

			let detail = [
                {
                    nama_item: "usaha",
                    isi_item: JSON.stringify(formData.dataUsaha)
                }
            ];

			let bodyRaw = {
				...dt,
				tanggal_lahir: dateFormat(new Date(dt.tanggal_lahir), 'yyyy-mm-dd'),
				tujuan_pembuatan: "Surat Keterangan Usaha",
				detail,
			}
			if (dt.uuid === '') {
				if (kioskMode) {
					bodyRaw.id_jenis = props.id_jenis
				} else {
					bodyRaw.id_jenis = props.location.state.uuid
				}
			}

			let psn = "";
			let resstat = 204;
			let metode = "create";
			if (bodyRaw.uuid === "") {
				psn = "Tambah";
				resstat = 201;
				bodyRaw.uuid = null;
			} else {
				psn = "Ubah";
				resstat = 200;
				metode = "update";
			}
			Post(
				"surat-keterangan/grup/" + metode + "/with-detail",
				bodyRaw.uuid,
				bodyRaw,
				res => {

					// For testing
					if (props.resSubmit) {
						props.resSubmit(res.status)
					}

					// this.tutupForm();
					setFormData({
						...formData,
						status: {
							...formData.status,
							btnForm: false,
							form: false,
						}
					})
					setIsOpen(false)

					if (kioskMode) {
                        if (res.status === resstat) {
                            let dataAntrian = {
                                nama: props.data.results.nama,
                                nik: props.data.results.id,
                                keterangan: '',
                                uuid_surat:res.data.results.uuid_surat,
                                kode_surat:res.data.results.kode_surat,
                            };

                            // Set Data Surat
                            props.getDataSurat(res.data.results);

							setTimeout(function () {
								Get('persetujuan/kiosk/' + dataAntrian.uuid_surat + '/' + props.id_jenis, null, (res2) => {
									
									props.setLoadingPreview(false)

									if (res2.code === 201) {
										props.getAntrian('Surat Keterangan Usaha', 'berhasil', false, dataAntrian);
									}
									else {
										props.getAntrian('Surat Keterangan Usaha', 'gagal');
									}
								});
							}.bind(this),1000)
                        }
                        else{
							props.setLoadingPreview(false)
                            props.getAntrian('Surat Keterangan Usaha', 'gagal');
                        }
					} else {
						if (res.status === resstat) {
							const alertData = {
                                get_data_surat:{
                                    uuid_surat:res.data.results.uuid_surat,
                                    kode_surat:res.data.results.kode_surat,
                                },
                                status:{
                                    frmPreviewDraft: true,
                                    jenis_form: psn,
                                }
                                // show: true,
                                // basicType: "success",
                                // basicTitle: "Data Surat Keterangan Usaha",
                                // pesanAlert: "Berhasil " + psn + " Data",
                                // successAlert: true
							};
							setAlert({
								loadingPreview: false
							})
							setAlert(alertData);
						} else {
							const alertData = {
								show: true,
								basicType: "danger",
								basicTitle: "Data Surat Keterangan Usaha",
								pesanAlert: "Gagal " + psn + " Data"
							}
							setAlert({
								loadingPreview: false
							})
							setAlert(alertData)
						}

						// Refresh list
						setStatusRefresh(true)
					}

				}
			);
		} else {
			if (kioskMode){
				props.getAntrian('Surat Keterangan Usaha', 'gagal', true);
				props.setLoadingPreview(false)
			}
			else{
				const alertData = {
					show: true,
					basicType: "info",
					basicTitle: "Data Belum Lengkap",
					pesanAlert: "Mohon isi seluruh data dengan benar"
				}
				setAlert({
					loadingPreview: false
				})
				setAlert(alertData)
			}
		}
	};

	return (
		<Modal
			classNames={{ overlay: 'card-scrollable' }}
			open={isOpen}
			onClose={() => {
				setIsOpen(false)
			}}
			closeOnEsc={false}
			closeOnOverlayClick={false}
			style={{
				maxwidth: 'unset'
			}}
		>
			<Form
				id="modalForm"
				data-testid="form-create"
				className="theme-form"
				onSubmit={simpan}
			>
				<div
					onMouseDown={(e) => {
						let slider = document.querySelector('.card-scrollable');
						setDraggable({
							isDown: true,
							startY: e.pageY - slider.offsetTop,
							scrollUp: slider.scrollTop,
						})
					}}
					onMouseLeave={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseUp={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseMove={(e) => {
						e.preventDefault();

						let slider = document.querySelector('.card-scrollable');

						if (!draggable.isDown) {
							return;
						}

						const y = e.pageY - slider.offsetTop;
						const startY = draggable.startY;
						const walk = y - startY;
						slider.scrollTop = draggable.scrollUp - walk;
					}}
				>
					<div className="modal-header">
						<h5 className="modal-title">{dt.uuid == '' ? 'Tambah' : 'Edit'} Surat Keterangan Usaha</h5>
					</div>
					<div className="modal-body">
						<p>
							Data identitas akan terisi secara otomatis saat NIK dipilih.
							Jika ada ketidak sesuaian data, silakan ubah di data master
							penduduk.
						</p>
						<input
							className="form-control"
							id="uuid"
							type="hidden"
							placeholder=""
							defaultValue={dt.uuid}
						/>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="nik"
							>
								NIK Pemohon
							</Label>
							<Col sm="9">
								<div data-testid="selectNIK">
									<Select
										inputId="nik"
										name="nik"
										classNamePrefix="select"
										onChange={e => {
											getPenduduk(e);
										}}
										defaultValue={formData.nikStat}
										value={formData.nikStat}
										options={formData.frmNik}
										placeholder="Pilih NIK Pemohon"
										onInputChange={e => handleInputChangeNIK(e, "nik")}
										isClearable
									/>
								</div>
							</Col>
						</FormGroup>
						<div style={{ display: formData.status.dataPenduduk }}>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Nama Pemohon
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="nama"
										type="text"
										placeholder="Nama Pemohon"
										value={dt.nama_pemohon}
										readOnly
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tempat Lahir
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="tempat_lahir"
										type="text"
										placeholder="Tempat Lahir"
										value={dt.tempat_lahir}
										readOnly
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tanggal Lahir
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="tanggal_lahir"
										type="text"
										placeholder="Tanggal Lahir"
										value={new Date(dt.tanggal_lahir).toLocaleDateString("id-ID")}
										readOnly
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
                            <FormGroup className="row">
                                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                                    Alamat
                                </Label>
                                <Col sm="9">
                                    <input
                                        className="form-control"
                                        id="alamat_kk"
                                        type="text"
                                        // placeholder="Tempat Lahir"
                                        value={dt.alamat_kk}
                                        readOnly
                                        style={{ backgroundColor: "#c9d1d8" }}
                                        disabled
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup className="row">
                                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                                    Wilayah
                                </Label>
                                <Col sm="9">
                                    <input
                                        className="form-control"
                                        id="alamat"
                                        type="text"
                                        // placeholder="Tempat Lahir"
                                        value={dt.alamat}
                                        readOnly
                                        style={{ backgroundColor: "#c9d1d8" }}
                                        disabled
                                    />
                                    <small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
                                </Col>
                            </FormGroup>
						</div>
						<FormGroup className="row">
							<Label
								className="col-sm-6 col-form-label text-center"
								htmlFor="inputEmail3"
								style={labelJenisStyle('usaha')}
							>
								<span
									style={{ width: '100%', cursor: "pointer", display: "block", color: textColorStyle('usaha') }}
									onClick={e => {
										setFormData({
											...formData,
											jenisForm: "usaha"
										})
										// this.setState({ jenisForm: "usaha" });
										if (props.getJenisInput2) {
											props.getJenisInput2("usaha")
										}
									}}
								>
									Usaha
								</span>
								{/* <Link
									to={{
										pathname: props.myroute,
										state: props.location.state
									}}
									data-testid="btnInputUsaha"
									onClick={e => {
										setFormData({
											...formData,
											jenisForm: "usaha"
										})
										// this.setState({ jenisForm: "usaha" });
										if (props.getJenisInput) {
											props.getJenisInput("usaha")
										}
									}}
									style={{ color: textColorStyle('usaha') }}
								>
									Usaha
								</Link> */}
							</Label>
							<Label
								className="col-sm-6 col-form-label text-center"
								htmlFor="inputEmail3"
								style={labelJenisStyle('kebun')}
							>
								<span
									style={{ width: '100%', cursor: "pointer", display: "block", color: textColorStyle('kebun') }}
									onClick={e => {
										setFormData({
											...formData,
											jenisForm: "kebun"
										})
										// this.setState({ jenisForm: "kebun" });
										if (props.getJenisInput2) {
											props.getJenisInput2("kebun")
										}
									}}
								>
									Perkebunan
								</span>
								{/* <Link
									to={{
										pathname: props.myroute,
										state: props.location.state
									}}
									data-testid="btnInputKebun"
									onClick={e => {
										setFormData({
											...formData,
											jenisForm: "kebun"
										})
										// this.setState({ jenisForm: "kebun" });
										if (props.getJenisInput2) {
											props.getJenisInput2("kebun")
										}
									}}
									style={{ color: textColorStyle('kebun') }}
								>
									Perkebunan
								</Link> */}
							</Label>
						</FormGroup>
						<FormGroup className="row">
							<Label className="col-sm-2 col-form-label font-weight-bold" htmlFor="inputEmail3">
								Form {formData.jenisForm}
							</Label>
						</FormGroup>

						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Jenis {formData.jenisForm === "usaha" ? "Usaha" : "Kebun"}
							</Label>
							<Col sm="9">
								<input
									data-testid="jenis_usaha"
									name="jenis_usaha"
									className="form-control"
									id="jenis_usaha"
									type="text"
									// required
									placeholder={"Masukkan jenis " + formData.jenisForm}
									defaultValue=""
								/>
							</Col>
						</FormGroup>
						{formData.jenisForm === "usaha" ? (
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Nama Tempat Usaha
								</Label>
								<Col sm="9">
									<input
										data-testid="nama_tempat_usaha"
										name="nama_tempat_usaha"
										className="form-control"
										id="nama_tempat_usaha"
										type="text"
										// required
										placeholder="Contoh: Warung Ayam Geprek Pak Kumis"
										defaultValue=""
									/>
								</Col>
							</FormGroup>
						) : ''}
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Lokasi {formData.jenisForm === "usaha" ? "Usaha" : "Kebun"}
							</Label>
							<Col sm="9">
								<input
									data-testid="lokasi"
									name="lokasi"
									className="form-control"
									id="lokasi"
									type="text"
									// required
									placeholder="Contoh: Jalan Sudirman No.47"
									defaultValue=""
								/>
							</Col>
						</FormGroup>
						{formData.jenisForm === "kebun" ? (
							<>
								<FormGroup className="row">
									<Label
										className="col-sm-3 col-form-label"
										htmlFor="inputEmail3"
									>
										Umur
									</Label>
									<Col sm="9">
										<input
											data-testid="umur"
											name="umur"
											className="form-control"
											id="umur"
											type="text"
											// required
											placeholder="Contoh: 5 tahun"
											defaultValue=""
										/>
									</Col>
								</FormGroup>
								<FormGroup className="row">
									<Label
										className="col-sm-3 col-form-label"
										htmlFor="inputEmail3"
									>
										Luas lahan
									</Label>
									<Col sm="9">
										<input
											data-testid="luas_kebun"
											name="luas_kebun"
											className="form-control"
											id="luas_kebun"
											type="text"
											// required
											placeholder="Contoh: 100 hektare"
											defaultValue=""
										/>
									</Col>
								</FormGroup>
							</>
						) : ''}

						<FormGroup className="row">
							<Label
								className="col-sm-12 col-form-label text-right"
								htmlFor="inputEmail3"
							>
								<button
									data-testid="btnTambahUsaha"
									type="button"
									onClick={addUsaha}
									className="btn btn-success small"
								>
									Tambah Data 
								</button>
							</Label>
						</FormGroup>
						{formData.dataUsaha.length !== 0 ? (
							formData.dataUsaha.map((dt, index) => {
								return (
									<>
										<Label
											className="col-sm-8 col-form-label"
											htmlFor="inputEmail3"
										>
											{ "Usaha / Kebun " + (index + 1)}
										</Label>
										<Label
											className="col-sm-4 col-form-label"
											htmlFor="inputEmail3"
										>
											<Button
												size="xs"
												color="danger"
												className="btn-icon"
												onClick={() => hapusUsaha(index)}
											>
												<i className="fa fa-trash"></i>
											</Button>{" "}
										</Label>

										{/* List Usaha yang telah ditambahkan dari modal */}
										{typeof dt.jenis_usaha !== "undefined" ? (
											dt.jenis_usaha !== "" ? (
												<>
													<Label
														className="col-sm-4 col-form-label"
														htmlFor="inputEmail3"
													>
														Jenis Usaha
													</Label>
													<Label
														className="col-sm-2 col-form-label"
														htmlFor="inputEmail3"
													>
														:
													</Label>
													<Label
														className="col-sm-4 col-form-label"
														htmlFor="inputEmail3"
													>
														{dt.jenis_usaha}
													</Label>
												</>
											) : ''
										) : ''}
										{typeof dt.nama_tempat_usaha !== "undefined" ? (
											dt.nama_tempat_usaha !== "" ? (
												<>
													<Label
														className="col-sm-4 col-form-label"
														htmlFor="inputEmail3"
													>
														Nama Tempat usaha
													</Label>
													<Label
														className="col-sm-2 col-form-label"
														htmlFor="inputEmail3"
													>
														:
													</Label>
													<Label
														className="col-sm-4 col-form-label"
														htmlFor="inputEmail3"
													>
														{dt.nama_tempat_usaha}
													</Label>
												</>
											) : ''
										) : ''}
										{typeof dt.lokasi !== "undefined" ? (
											dt.lokasi !== "" ? (
												<>
													<Label
														className="col-sm-4 col-form-label"
														htmlFor="inputEmail3"
													>
														Lokasi
													</Label>
													<Label
														className="col-sm-2 col-form-label"
														htmlFor="inputEmail3"
													>
														:
													</Label>
													<Label
														className="col-sm-4 col-form-label"
														htmlFor="inputEmail3"
													>
														{dt.lokasi}
													</Label>
												</>
											) : ''
										) : ''}
										{typeof dt.umur !== "undefined" ? (
											dt.umur !== "" ? (
												<>
													<Label
														className="col-sm-4 col-form-label"
														htmlFor="inputEmail3"
													>
														Umur
													</Label>
													<Label
														className="col-sm-2 col-form-label"
														htmlFor="inputEmail3"
													>
														:
													</Label>
													<Label
														className="col-sm-4 col-form-label"
														htmlFor="inputEmail3"
													>
														{dt.umur}
													</Label>
												</>
											) : ''
										) : ''}
										{typeof dt.luas_kebun !== "undefined" ? (
											dt.luas_kebun !== "" ? (
												<>
													<Label
														className="col-sm-4 col-form-label"
														htmlFor="inputEmail3"
													>
														Luas Kebun
													</Label>
													<Label
														className="col-sm-2 col-form-label"
														htmlFor="inputEmail3"
													>
														:
													</Label>
													<Label
														className="col-sm-4 col-form-label"
														htmlFor="inputEmail3"
													>
														{dt.luas_kebun}
													</Label>
												</>
											) : ''
										) : ''}
										{/* End List Usaha yang telah ditambahkan dari modal */}

									</>
								);
							})
						) : (
							<>
								<Label
									className="col-sm-12 col-form-label text-center"
									htmlFor="inputEmail3"
								>
									Data usaha belum ada
								</Label>
							</>
						)}
					</div>
					<div className="modal-footer">
						<button
							type="button"
							className="btn btn-warning"
							onClick={() => {
								// Tutup modal
								setFormData({
									...formData,
									status: {
										...formData.status,
										form: false
									}
								})
								setIsOpen(false)
							}}
						>
							Tutup
						</button>
						<button
							data-testid="btnSubmitCreate"
							type="submit"
							className="btn btn-primary-custom"
							// disabled={formData.status.btnForm}
						>
							Simpan
						</button>
					</div>
				</div>
			</Form>
		</Modal>
	);
}

export default ModalSuratUsaha;
